<template>
     <div v-if="actor.img_full" class="single-actor-row">
                <a :href="actor.link">
                    <picture>
                        <source media="(min-width: 1440px)" :srcset="actor.img_full" width="800" height="500">
                        <source media="(min-width: 768px)" :srcset="actor.img_large" width="768" height="500">
                        <source media="(min-width: 320px)" :srcset="actor.img_medium" width="320" height="500">

                        <img :data-src="actor.img_full" loading="lazy" width="750" height="750" class="object-cover" />

                    </picture>
                    <div class="name-actor absolute bottom-0">
                        <span class="text-2.6rem block left-2 relative title-actor">{{actor.title}}</span>
                    </div>
                </a>

            </div>
</template>

<script>
    export default {
       name: "actor-swiper",
        props:{
            actor:{
                type: Object,
                default:null
            }
        }
    }
    
</script>

<style lang="scss" scoped>
.name-actor{
    background-image: linear-gradient(to bottom, transparent 0%, rgba(#000, 0.8) 100%);
    background-blend-mode: overlay;
    height:80px;
    width:100%;
    .title-actor{
        height: fit-content;
        top: 0;
    }

    span{
        text-shadow: rgba(black, 0.5) 0 10px 10px;
        top:30px;
    }
}
</style>